import { render, staticRenderFns } from "./ChangeBusinessName.vue?vue&type=template&id=561382c2&scoped=true&"
import script from "./ChangeBusinessName.vue?vue&type=script&lang=ts&"
export * from "./ChangeBusinessName.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeBusinessName.vue?vue&type=style&index=0&id=561382c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561382c2",
  null
  
)

export default component.exports